import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderFormWithGuidanceComponent } from './form-with-guidance.component';
import { RappiderAlertModule } from '../alert/alert.module';
import { RappiderEditFormModule } from '../edit-form/edit-form.module';
import { RappiderMarkdownViewerModule } from '../markdown-viewer/markdown-viewer.module';


@NgModule({
  declarations: [
    RappiderFormWithGuidanceComponent
  ],
  imports: [
    CommonModule,
    RappiderEditFormModule,
    RappiderMarkdownViewerModule,
    RappiderAlertModule
  ],
  exports: [
    RappiderFormWithGuidanceComponent
  ]
})
export class RappiderFormWithGuidanceModule { }
